import { MappedService, Service } from 'src/app/models/service.model';

export function mapServiceOption(service: Service): Service {
  return {
    ...service,
    alias: service?.Vendor__r?.Display_Alias__c,
  };
}

export function mapMultiServiceOption(service: Service): MappedService | null {
  if (!service.Z_Location__c) {
    return null;
  }

  return {
    bandwidth: service?.Bandwidth_Text__c,
    alias: service?.Vendor__r?.Display_Alias__c,
    id: service.Id,
    nit: service.Name,
    product: service.RecordType.Name,
    locationId: service.Z_Location__c,
    locationName: service.Z_Location__r.Name,
    disabled: false,
  };
}
